import React,{useState} from "react";
import {
  setUser,
} from "../store/features/user/userSlice";
import { connect } from "react-redux";
import { makeStyles } from 'tss-react/mui';
import { Tabs, Tab, Grid } from "@mui/material";
import TabPanel from "../components/tabPanel";
import UserDetails from "../components/userDetails";
import AdditionalSettings from "../components/additionalSettings";
import EmergencySettings from "../components/emergencySettings";
import { updateUserProfile, getUserProfileData } from "../utils/utils";
import HelpMenu from "../components/helpMenu";

const mapDispatchToProps = {
  setUser,
};

const useStyles = makeStyles()((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },
  title: {
    fontSize: "60px",
    fontWeight: "300",
    // Proportional, as it was before the Material UI upgrade. Without it the
    // heading inherits the fixed 24px body line height and its 60px letters
    // overflow onto the app bar above and the tabs below.
    lineHeight: 1.43,
    textAlign: "center",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  gridContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  tabs: {
    marginBottom: theme.spacing(1),
    "& .MuiTab-root": {
      textTransform: "none",
      fontSize: 15,
      fontWeight: 500,
      minHeight: 44,
    },
  },
  // One centred column for the single-card tabs.
  narrow: {
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 680,
    },
  },
}));

function a11yProps(index) {
  return {
    id: `nav-tab-${index}`,
    "aria-controls": `nav-tabpanel-${index}`,
  };
}

const UserProfile = (props) => {
    const { classes } = useStyles();
    const { session, setUser, user } = props;

    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    

    return (
      <div className={classes.root}>
        <HelpMenu />
        <Grid container direction="column" sx={{
          alignItems: "center"
        }}>
          <Grid size={12}>
            <h1 className={classes.title}>My Profile</h1>
          </Grid>
          {/* Sized to its content so the centred column centres the tabs; the
              new Grid makes a size-12 item truly full width, which pushed the
              tabs to the left. maxWidth keeps them scrollable on small screens. */}
          <Grid size="auto" sx={{ maxWidth: "100%" }}>
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              className={classes.tabs}
            >
              <Tab label="User details" {...a11yProps(0)} />
              <Tab label="Additional settings" {...a11yProps(1)} />
              <Tab label="Emergency" {...a11yProps(2)} />
            </Tabs>
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          spacing={0}
          sx={{
            alignItems: "center",
            justifyContent: "center"
          }}>
          <Grid className={classes.gridContainer} size={12}>
            <TabPanel value={value} index={0}>
              <div className={classes.narrow}>
                <UserDetails
                  user={user}
                  setUser={setUser}
                  updateUserProfile={updateUserProfile}
                  getUserProfileData={getUserProfileData}
                  session={session}
                />
              </div>
            </TabPanel>
          </Grid>
          <TabPanel value={value} index={1}>
            <Grid size={12}>
              <AdditionalSettings
                user={user}
                setUser={setUser}
                updateUserProfile={updateUserProfile}
                getUserProfileData={getUserProfileData}
                session={session}
              />
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Grid size={12}>
              <div className={classes.narrow}>
                <EmergencySettings
                  user={user}
                  setUser={setUser}
                  updateUserProfile={updateUserProfile}
                  session={session}
                />
              </div>
            </Grid>
          </TabPanel>
        </Grid>
      </div>
    );
};

const mapStateToProps = (state) => {
    return { 
        session: state.session, 
        user: state.user 
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
